import React, { useState, useEffect } from 'react';
import { Container, VStack, Heading, Text, Button, Box, Flex } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useActivityResponse } from '../../../hooks/useActivityResponse';
import { TextQuestion } from '../../../components/activities/TextQuestion';

const DemoActivityPage: React.FC = () => {
  const navigate = useNavigate();
  
  // Load the activity response
  const { activity, response, isLoading, saveResponse } = useActivityResponse('demo_pre_chat_question');

  const [hasSubmitted, setHasSubmitted] = useState(false); // Always start with false to show the activity

  // Check if there's already a response after loading
  useEffect(() => {
    if (!isLoading && response?.response_value) {
      setHasSubmitted(true);
    }
  }, [isLoading, response]);

  const handleResponseChange = async (responseValue: string | null) => {
    if (!responseValue) return;
    try {
      await saveResponse(responseValue);
      setHasSubmitted(true);
    } catch (error) {
      console.error('Failed to save response:', error);
    }
  };

  const handleContinue = () => {
    navigate('/s/chat');
  };

  if (isLoading) {
    return (
      <Container maxW="4xl" py={8}>
        <VStack spacing={6}>
          <Text>Loading...</Text>
        </VStack>
      </Container>
    );
  }

  return (
    <Container maxW="4xl" py={8}>
      <VStack spacing={8} align="stretch">
        <Box>
          <Heading size="lg" mb={4}>
            Before we begin...
          </Heading>
          <Text fontSize="lg" color="gray.600">
            Please take a moment to answer this question. Your response will help me provide 
            a more personalized learning experience.
          </Text>
        </Box>

        {activity && (
          <Box>
            <TextQuestion
              activityKey="demo_pre_chat_question"
              required={false}
              placeholder="Share your thoughts here..."
              rows={4}
              onResponseChange={handleResponseChange}
            />
          </Box>
        )}

        {hasSubmitted && (
          <Flex justify="center">
            <Button
              colorScheme="purple"
              size="lg"
              onClick={handleContinue}
            >
              Continue to Chat
            </Button>
          </Flex>
        )}
      </VStack>
    </Container>
  );
};

export default DemoActivityPage;
